export default __webpack_public_path__ + "static/media/enter.8178aa8e.svg";